module.exports = __webpack_public_path__ + "d1405bbe.png";